import React, { useContext, useEffect, useState } from "react";
import AppContext from "../../container/context";
import api from "../../services/api";
import Form from "../../components/form";
import ActionTable from "../../components/table/ActionTable";

export default function EscolasExclusividade({ materialId }) {
  const { notification } = useContext(AppContext);
  const [comboEscolas, setComboEscolas] = useState([]);
  const [escolasExclusividade, setEscolasExclusividade] = useState([]);

  useEffect(() => {
    listarEscolas();
  }, []);

  const carregarComboEscolas = (escolas) => {
    api
      .get("escolas/listar", { ativas: true })
      .then((res) => {
        const comboEscolas = res.filter(
          (e) =>
            escolasExclusividade.filter((ee) => ee.escolaId === e.id).length ===
            0
        );

        setComboEscolas(res);
      })
      .catch((err) => notification("error", "Erro ao listar as escolas"));
  };

  const listarEscolas = () => {
    api
      .get("materiais/escolasExclusividade", {
        materialId,
      })
      .then((escolasExclusividade) => {
        setEscolasExclusividade(escolasExclusividade);
        carregarComboEscolas(escolasExclusividade);
      })
      .catch(() =>
        notification("error", "Erro ao listar as escolas com venda exclusiva.")
      );
  };

  const camposInclusaoEscola = () => {
    return {
      escolaId: {
        label: "Escola",
        type: "select",
        emptyItem: true,
        array: {
          data: comboEscolas,
          value: "id",
          desc: "nomeFantasia",
        }
      },
    };
  };

  const inserirEscolaExclusividade = (form) => {
    api
      .put("materiais/inserirEscolaExclusividade", {
        materialId,
        escolaId: form.escolaId,
      })
      .then(() => {
        notification("success", "Exclusividade salva para a escola.");
        listarEscolas();
      })
      .catch((err) => {
        console.log(err);
        notification("error", "Erro ao inserir a exclusividade.");
      });
  };

  const removerEscolaExclusividade = (escolaId) => {
    api
      .delete("materiais/removerEscolaExclusividade", {
        materialId,
        escolaId,
      })
      .then(() => {
        notification("warning", "Exclusividade removida para a escola.");
        listarEscolas();
      })
      .catch((err) => {
        console.log(err);
        notification("error", "Erro ao inserir a exclusividade.");
      });
  };

  const fInclusaoEscola = {
    title: "Inserir escola",
    form: camposInclusaoEscola(),
    submit: {
      label: "Adicionar",
      action: inserirEscolaExclusividade,
    },
  };

  const tEscolasExclusividade = {
    title: "Escolas com exibição exclusiva",
    key: "escolaId",
    array: escolasExclusividade,
    columns: [
      {
        name: "escolaNomeFantasia",
        label: "Escola",
      },
    ],
    actions: [
      {
        name: "delete",
        icon: "zmdi zmdi-delete",
        action: removerEscolaExclusividade,
      },
    ],
  };

  return (
    <div>
      <h3>Escolas (Exibição exclusiva)</h3>
      <Form formData={fInclusaoEscola} />

      {escolasExclusividade.length > 0 ? (
        <ActionTable structure={tEscolasExclusividade} />
      ) : (
        <h4>Material sem sem exclusividade de exibição.</h4>
      )}
    </div>
  );
}
